import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/pro-light-svg-icons/faArrowRight";

function SessionEnded(props) {

  const search = props.location.search;
  const params = new URLSearchParams(search);
  let redirect = params.get('redirect');
  redirect = redirect.replace('+', '#')
  redirect = redirect.replace(' ', '#')
  const { t } = useTranslation('common');

  const reload = () => {
    window.location.href = redirect
  }

  return (
    <div>
      <div className="app flex-row align-items-center bg-image">
        <div className="tw-w-full tw-max-w-sm tw-p-4">
          <h1 className="tw-text-xl tw-text-center">{t('workspaces.session-ended')}</h1>
          <p className="tw-text-center">{t('workspaces.session-ended-text')}</p>
          <button
            className="actionbutton tw-group/button tw-mt-4 !tw-py-4 tw-bg-blue-500 !tw-shadow-[0_0_9px_rgba(0,0,0,0.15)] hover:!tw-bg-slate-700 tw-border-t tw-border-0 tw-border-solid tw-border-white/25 hover:tw-border-white/10"
            style={{ cursor: "pointer" }}
            onClick={reload}
          >
            <div className="tw-transition-all tw-translate-x-2 group-hover/button:-tw-translate-x-1">{t("workspaces.restart-session")}</div>
            <div className="tw-transition-all -tw-translate-x-1 group-hover/button:tw-translate-x-3 tw-opacity-0 group-hover/button:tw-opacity-100"><FontAwesomeIcon icon={faArrowRight} /></div>
          </button>

        </div>
      </div>
    </div>
  );
}
export default SessionEnded;
